import { type Image } from '../../../../shared/dyResponse';
import { enrichWithImgix } from '../../../helper/enrichWithImgix';

export type PageTile = {
    trackingName: string;
    title: string;
    image: Image;
    url: string;
};

export const pageTilesJS = [
    {
        title: 'Geschenke für Männer',
        image: enrichWithImgix({
            alt: 'Geschenke für Männer',
            src: 'https://www.jochen-schweizer.de/images/https%3A%2F%2Fmain.static.jsmd-group.com%2Fassets%2Fnew_default_upload_bucket%2FJS_LP_Fruehling-fuer-Maenner_DE_1646x686px.jpg?w=892&h=372&fit=clip&auto=format%2Ccompress&cs=srgb&dpr=1&q=75&s=dd696ec1a8fa489663b9bbce69ec88ff',
        }),
        url: '/geschenke/fuer-maenner/l/83j6y',
        trackingName: 'maenner',
    },
    {
        title: 'Geschenke für Paare',
        image: enrichWithImgix({
            alt: 'Geschenke für Paare',
            src: 'https://www.jochen-schweizer.de/images/https%3A%2F%2Fmain.static.jsmd-group.com%2Fassets%2Fnew_default_upload_bucket%2FJS_LP_Fruehling-fuer-Paare_DE_1646x686px_V3%2520%25281%2529.jpg?w=892&h=372&fit=clip&auto=format%2Ccompress&cs=srgb&dpr=1&q=75&s=f3477e91ae4a9b0f90fb885fe8d199e7',
        }),
        url: '/geschenke/fuer-paare/l/kth96',
        trackingName: 'paare',
    },
    {
        title: 'Kurzurlaub',
        image: enrichWithImgix({
            alt: 'Kurzurlaub',
            src: 'https://www.jochen-schweizer.de/images/https%3A%2F%2Fmain.static.jsmd-group.com%2Fassets%2F_default_upload_bucket%2Freisen_slider.jpg?w=276&h=190&fit=max&auto=format%2Ccompress&cs=srgb&dpr=2&q=50&s=3aee00013120f1de57daa850eda880b0',
        }),
        url: '/kurzurlaub/l/d48wi',
        trackingName: 'kurzurlaub',
    },
    {
        title: 'Alle Erlebnisse',
        image: enrichWithImgix({
            alt: 'Alle Erlebnisse',
            src: 'https://www.jochen-schweizer.de/images/https%3A%2F%2Fmain.static.jsmd-group.com%2Fassets%2F_default_upload_bucket%2Fhttp-_www.jochen-schweizer_30.jpg?w=276&h=190&fit=max&auto=format%2Ccompress&cs=srgb&dpr=2&q=50&s=eb4e687841b9c3fb1a840b670c8a038d',
        }),
        url: '/alle-erlebnisse/l/79ifa',
        trackingName: 'alle erlebnisse',
    },
    {
        title: 'Fallschirmspringen',
        image: enrichWithImgix({
            alt: 'Fallschirmspringen',
            src: 'https://www.jochen-schweizer.de/images/https%3A%2F%2Fmain.static.jsmd-group.com%2Fassets%2F_default_upload_bucket%2Ffliegen-fallen-fallschirmspringenslider.jpg?w=276&h=190&fit=max&auto=format%2Ccompress&cs=srgb&dpr=2&q=50&s=108b953faec5dfd621fcbdc4a1677022',
        }),
        url: '/fliegen-fallen/fallschirmspringen/l/695dr',
        trackingName: 'fallschirmspringen',
    },
    {
        title: 'Geschenke für Frauen',
        image: enrichWithImgix({
            alt: 'Geschenke für Frauen',
            src: 'https://www.jochen-schweizer.de/images/https%3A%2F%2Fmain.static.jsmd-group.com%2Fassets%2Fnew_default_upload_bucket%2FJS_LP_Fruehling-fuer-Frauen_DE_1646x686px_V2.jpg?w=892&h=372&fit=clip&auto=format%2Ccompress&cs=srgb&dpr=1&q=75&s=f3f5b5fcaae546a9c009ae2d388869fe',
        }),
        url: '/geschenke/fuer-frauen/l/b1p5i',
        trackingName: 'frauen',
    },
    {
        title: 'Wellness',
        image: enrichWithImgix({
            alt: 'Wellness',
            src: 'https://www.jochen-schweizer.de/images/https%3A%2F%2Fmain.static.jsmd-group.com%2Fassets%2Fnew_default_upload_bucket%2FThumbnail_Wellnesstag.jpg?w=276&h=190&fit=max&auto=format%2Ccompress&cs=srgb&dpr=2&q=50&s=d6f07c652806b60e90b35619c199455b',
        }),
        url: '/wellness/l/we5gm',
        trackingName: 'wellness',
    },
    {
        title: 'Weihnachtsgeschenke',
        image: enrichWithImgix({
            alt: 'Weihnacht',
            src: 'https://www.jochen-schweizer.de/images/https%3A%2F%2Fmain.static.jsmd-group.com%2Fassets%2Fnew_default_upload_bucket%2FLP_XMAS25_Weihnachtsgeschenke_1646x686px.jpg?w=892&h=372&fit=clip&auto=format%2Ccompress&cs=srgb&dpr=1&q=75&s=d0000d2230b498a029cf61ef530d5f53',
        }),
        url: '/geschenke/weihnachtsgeschenke/l/8piw6',
        trackingName: 'weihnacht',
    },
    {
        title: 'Motorpower',
        image: enrichWithImgix({
            alt: 'Motorpower',
            src: 'https://www.jochen-schweizer.de/images/https%3A%2F%2Fmain.static.jsmd-group.com%2Fassets%2Fnew_default_upload_bucket%2Fpexels-abdulwahab-alawadhi-3422964_bb_CI22_re_1646x686.jpg?w=892&h=372&fit=max&auto=format%2Ccompress&cs=srgb&dpr=2&q=50&s=8ab76d9f89a7d45e2c9e0f36e5df0da2',
        }),
        url: '/motorpower/l/p6jmw',
        trackingName: 'motorpower',
    },
];

export const pageTilesMD = [
    {
        title: 'Kurzurlaub',
        image: enrichWithImgix({
            alt: 'Kurzurlaub',
            src: 'https://www.mydays.de/images/https%3A%2F%2Fmain.static.jsmd-group.com%2Fassets%2Fnew_default_upload_bucket%2FKurzurlaub_700x600%2520%25281%2529_1.jpg?w=276&h=190&fit=max&auto=format%2Ccompress&cs=srgb&dpr=2&q=50&s=ce26bf99df3c9517d733685a302e382a',
        }),
        url: '/kurzurlaub/l/g6ukx',
        trackingName: 'kurzurlaub',
    },
    {
        title: 'Alle Erlebnisgeschenke',
        image: enrichWithImgix({
            alt: 'Alle Erlebnisgeschenke',
            src: 'https://www.mydays.de/images/https%3A%2F%2Fmain.static.jsmd-group.com%2Fassets%2Fnew_default_upload_bucket%2FLifestyle_700x600_2.jpg?w=276&h=190&fit=max&auto=format%2Ccompress&cs=srgb&dpr=2&q=50&s=887daebe84b55a662b2d9816e6b83cdc',
        }),
        url: '/geschenkidee/alle-erlebnisgeschenke/l/o7trc',
        trackingName: 'alle erlebnisgeschenke',
    },
    {
        title: 'Geschenke für Paare',
        image: enrichWithImgix({
            alt: 'Geschenke für Paare',
            src: 'https://www.mydays.de/images/https%3A%2F%2Fmain.static.jsmd-group.com%2Fassets%2Fnew_default_upload_bucket%2FPLP_Header_Paare_1646x686px.jpeg?w=892&h=372&fit=clip&auto=format%2Ccompress&cs=srgb&dpr=1&q=75&s=cbccf7165f5a37d3faa6bb4c72dfe6b7',
        }),
        url: '/geschenkidee/geschenke-fuer-paare/l/g2oad',
        trackingName: 'paare',
    },
    {
        title: 'Besondere Hotels',
        image: enrichWithImgix({
            alt: 'Besondere Hotels',
            src: 'https://www.mydays.de/images/https%3A%2F%2Fmain.static.jsmd-group.com%2Fassets%2Fnew_default_upload_bucket%2Fthumbnail_Besondere-Hotels_700x600.jpg?w=276&h=190&fit=max&auto=format%2Ccompress&cs=srgb&dpr=2&q=50&s=407805d0831c9e515d13780fdd07d769',
        }),
        url: '/kurzurlaub/besondere-hotels/l/gw6as',
        trackingName: 'besondere hotels',
    },
    {
        title: 'Geschenke für Frauen',
        image: enrichWithImgix({
            alt: 'Geschenke für Frauen',
            src: 'https://www.mydays.de/images/https%3A%2F%2Fmain.static.jsmd-group.com%2Fassets%2Fnew_default_upload_bucket%2Flp_header_Geschenke-fuer-Frauen_1646x686.jpg?w=892&h=372&fit=max&auto=format%2Ccompress&cs=srgb&dpr=2&q=50&s=b3176a6c5aa0b9601ec3e42cbd7ad518',
        }),
        url: '/geschenkidee/geschenke-fuer-frauen/l/r2wnt',
        trackingName: 'frauen',
    },
    {
        title: 'Geschenke für Männer',
        image: enrichWithImgix({
            alt: 'Geschenke für Männer',
            src: 'https://www.mydays.de/images/https%3A%2F%2Fmain.static.jsmd-group.com%2Fassets%2Fnew_default_upload_bucket%2Flp_header_Geschenke-fuer-Maenner_1646x686.jpg?w=892&h=372&fit=clip&auto=format%2Ccompress&cs=srgb&dpr=1&q=75&s=ae991990b9dffb8e26df22657f68b6eb',
        }),
        url: '/geschenkidee/geschenke-fuer-maenner/l/pisx9',
        trackingName: 'maenner',
    },
    {
        title: 'Wellness',
        image: enrichWithImgix({
            alt: 'Wellness',
            src: 'https://www.mydays.de/images/https%3A%2F%2Fmain.static.jsmd-group.com%2Fassets%2Fnew_default_upload_bucket%2FLP_Spa_700x600.jpg?w=276&h=190&fit=max&auto=format%2Ccompress&cs=srgb&dpr=2&q=50&s=f91aabed84da07fd13df7f1dc3cf80bb',
        }),
        url: '/wellness/l/s4mj8',
        trackingName: 'wellness',
    },
    {
        title: 'Weihnachts&shy;geschenke',
        image: enrichWithImgix({
            alt: 'Weihnachtsgeschenke',
            src: 'https://www.mydays.de/images/https%3A%2F%2Fmain.static.jsmd-group.com%2Fassets%2Fnew_default_upload_bucket%2Flp_header_geschenkidee_weihnachtsgeschenke-fuer-frauen_1646x686_1.jpg?w=892&h=372&fit=clip&auto=format%2Ccompress&cs=srgb&dpr=1&q=75&s=834883bef3744523d26e543d61508a86',
        }),
        url: '/geschenkidee/weihnachtsgeschenke/l/cyjoe',
        trackingName: 'weihnacht',
    },
    {
        title: 'Wellness&shy;urlaub',
        image: enrichWithImgix({
            alt: 'Wellnessurlaub',
            src: 'https://www.mydays.de/images/https%3A%2F%2Fmain.static.jsmd-group.com%2Fassets%2Fnew_default_upload_bucket%2FSpa_Relaxen_700x600.jpg?w=276&h=190&fit=max&auto=format%2Ccompress&cs=srgb&dpr=2&q=50&s=0c6ef2ceab2b9df55c534058606073b2',
        }),
        url: '/kurzurlaub/wellnessurlaub/l/qu6o1',
        trackingName: 'wellnessurlaub',
    },
];
